module.exports = __webpack_public_path__ + "static/media/change-direction.128b69ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/change-direction.svg
// module id = 238
// module chunks = 0